<template>
  <ATable
    v-loading="loading"
    ref="table"
    class="no-pointer"
    :data="customItems"   
    :rowClassName="handleRowClassName" 
    hide-top-panel
    hide-pagination
    hide-button-insert
    border
  >
    <el-table-column
      type="index"
      label="No"          
      align="center"
      prop="index"
      :width="$width.index"
      :index="handleIndex"
    />
    <el-table-column
      label="구분"
      prop="type_id"
      width="50"
      :formatter="resolveType"
    />
    <el-table-column
      label="계좌"
      prop="account_id"
      width="150"
      :formatter="resolveAccount"
    />
    <el-table-column
      label="주계정"
      width="150"
      :formatter="resolveParentCategory"
    />
    <el-table-column
      label="부계정"
      prop="category_id"
      width="150"
      :formatter="resolveCategory"
    />
    <el-table-column
      prop="customer_name"
      label="거래처"
      width="200"
    />
    <el-table-column 
      label="비고" 
      prop="desc"
    />
    <el-table-column
      label="수입액"
      prop="income"
      width="100"
      class-name="cell-number cell-income"
      :formatter="util.numberFormat"
    />     
    <el-table-column
      label="지출액"
      prop="expense"
      width="100"
      class-name="cell-number cell-expense"
      :formatter="util.numberFormat"
    />
    <el-table-column
      label="잔액"
      prop="balance"
      width="100"
      class-name="cell-number"
      :formatter="util.numberFormat"
    />    
  </ATable>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "AssetDayView",
  data() {
    return {
      editingId: -1,
      oldItem: undefined,
    };
  },
  props: {  
    items: {
      default: function() { return []; },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['table_account', 'table_asset_category', 'table_customer']),
    accountItems() {
      return this.table_account.filter(a => a.use_flag === 'Y');
    },
    customItems() {
      let items = Object.assign([], this.items);
      let income = 0, expense = 0;
      items.forEach(item => {
        income += item.income;
        expense += item.expense;
      })
      items.push({
        is_sum: true, 
        account_id: "합 계",
        income: income,
        expense: expense,
      });
      return items;
    }
  },
  methods: {
    calcelEditing(data) {
      let index = this.items.findIndex(i => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },   
    resolveType(row, column, value) {
      if (!value) return "";
      return value === 2 ? "지출" : "수입";
    },
    resolveAccount(row, column, value) {
      if (!Number.parseInt(value)) {
        return value;
      }
      let item = this.table_account.find(a => a.id === value);
      return item ? item.name : '';
    },
    resolveParentCategory(row) {      
      let item = this.table_asset_category.find(a => a.id === row.category_id);
      if (!item) { return '';}
      let parent = this.table_asset_category.find(a => a.id === item.parent_id);
      return parent ? parent.name : '';
    },
    resolveCategory(row, column, value) {
      let item = this.table_asset_category.find(a => a.id === value);
      return item ? item.name : '';
    },
    handleIndex(index) {      
      if (index === this.customItems.length - 1) {
        return "";
      } else {
        return this.$refs.table.indexResolver(index) - 1;
      }      
    },
    handleRowClassName({row}) {
      if (!row.is_sum) { return ''; }
      return 'warning-row';
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) { return ; }
      if (this.editingId > -1) { 
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) { return; }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickedCreate() {      
      if (this.editingId > -1) { 
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = {id: 0, code: '', desc: null};
      this.items.push(this.oldItem)
    },
  },
}
</script>
